import { useSelector } from 'react-redux'

import { isOnFreeStageSelector } from 'features/billing/selectors'
import { eligibleForExtensionSelector } from 'features/billing/trial_extension'
import { eventsCountSelector } from 'selectors/current_user'

const ACTIVATED_USER_EVENT_THRESHOLD = 5

// User is eligible for the retrial offer if they:
// 1. have only had 1 trial in the past (eligible for extension)
// 2. have less than 5 events (un-activated)
// 3. are currently on the free plan
export const useRetrialOfferEligibility = () => {
  const eligibleForExtension = useSelector(eligibleForExtensionSelector)
  const eventsCount = useSelector(eventsCountSelector)
  const isFreeUser = useSelector(isOnFreeStageSelector)

  return eligibleForExtension && eventsCount < ACTIVATED_USER_EVENT_THRESHOLD && isFreeUser
}
